export const FULL_I18N_SCOPE = 'full' as const;
export const LOGIN_I18N_SCOPE = 'login' as const;

export type I18nPayloadScope = typeof FULL_I18N_SCOPE | typeof LOGIN_I18N_SCOPE;

export const normalizeI18nPayloadScope = (scope: string | null): I18nPayloadScope =>
    scope === LOGIN_I18N_SCOPE ? LOGIN_I18N_SCOPE : FULL_I18N_SCOPE;
